<template>
	<div id="div-main">
		<b-table
			striped hover class="mt-3"
			:items="vendors"
			:fields="fields"
         small
		><!-- table -->
			<template v-slot:cell(name)="row">
            <a :href="`vendor/${row.item.id}/edit`" role="link">{{row.item.name}}</a>
			</template>
         <template v-slot:cell(hasRealStocks)="row">
            <!-- b-form-checkbox size="lg" disabled v-model="row.item.hasRealStocks" ></b-form-checkbox --><!-- wow this is the most retarded thing I've implemented in my life. -->
            <b-form-checkbox v-if="row.item.hasRealStocks == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                             size="lg" disabled v-model="no" />
         </template>
         <template v-slot:cell(hasVirtualStocks)="row">
            <b-form-checkbox v-if="row.item.hasVirtualStocks == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                                size="lg" disabled v-model="no" />
         </template>
         <template v-slot:cell(deliveryNoteActive)="row">
            <b-form-checkbox v-if="row.item.deliveryNoteActive == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                                  size="lg" disabled v-model="no" />
         </template>
         <template v-slot:cell(autocompleteDeliveryNotes)="row">
            <b-form-checkbox v-if="row.item.autocompleteDeliveryNotes == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                                         size="lg" disabled v-model="no" />
         </template>
         <template v-slot:cell(isActive)="row">
            <b-form-checkbox v-if="row.item.isActive == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                        size="lg" disabled v-model="no" />
         </template>         
		</b-table>
	</div>
</template>
<script>
export default {
   data () {
      return {
         yes: true,
         no: false,
         vendors: [ ],
         currencies: [ ],
         fields: [
            { key: 'id'                       , label: '#'                                    , sortable: true ,                                        },
            { key: 'skuPrefix'                , label: 'SKU'                                  , sortable: true ,                                        },
            { key: 'name'                     , label: 'Name'                                 , sortable: true ,                                        },
            { key: 'country'                  , label: 'Land'                                 , sortable: true , formatter: x => x.countryName          },
            { key: 'deliveryClass'            , label: 'LK'                                   , sortable: true ,                                        },
            { key: 'deliverygroup'            , label: 'Versandgruppe'                        , sortable: true , formatter: x => x.name                 },
            { key: 'incomeFine'               , label: 'Strafertrag'                          , sortable: true ,                                        },
            { key: 'currencyId'               , label: 'Währung'                              , sortable: true , formatter: this.currencyFormatter      },
            { key: 'hasRealStocks'            , label: 'Real Stocks'                          , sortable: true , formatter: x => (1 == x.hasRealStocks) }, //idk why this won't cast to bool. Would expect fmt to pipe into "row" variable.
            { key: 'hasVirtualStocks'         , label: 'Virtual Stocks'                       , sortable: true ,                                        },
            { key: 'deliveryNoteActive'       , label: 'Wareneingang aktiv'                   , sortable: true ,                                        },
            { key: 'autocompleteDeliveryNotes', label: 'Lieferscheine automatisch abschließen', sortable: true ,                                        },
            { key: 'mainVendorId'             , label: 'Hauptlieferant'                       , sortable: true , formatter: this.mainVendorFormatter    },
            { key: 'handlingTime'             , label: 'Handlingtime'                         , sortable: true ,                                        },
            { key: 'isActive'                 , label: 'ist Active'                           , sortable: true ,                                        },
         ]
      }
   },
   methods: {
      currencyFormatter(currencyId) {
         if(!currencyId) return "-";
         try{
            return this.currencies.find( currency => currencyId == currency.id ).code;
         }catch(e) { return "ERROR" }
      },
      
      mainVendorIdFormatter(mainVendorId) {
         if(!mainVendorId) return "-";
         try{
            return this.vendors.find( vendor => vendor.id == mainVendorId).name;
         }catch(e) { return "ERROR" }
      },
   },
   created() {
      Promise.all([
         axios.get("/vendor/all"),
         axios.get("/currency/all")
      ]).then( ([rVendors, rCurrencies]) => {
         this.vendors = rVendors.data.sort((v,w) => v.name.localeCompare(w.name));
         lo
         this.currencies = rCurrencies.data;
      });
   }
}
</script>
